import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'duration'
})

export class DurationPipe implements PipeTransform {

  transform(value: any, type: any) {
    if(!type) {
      return (value !== undefined ? moment.utc( value * 1000 ).format('HH$0mm$1').replace('$0', 'h').replace('$1', 'min') : '-');
    }
    if(type == "hh:mm:ss") {
      return (value !== undefined ? moment.utc( value * 1000 ).format('HH:mm:ss').replace('$0', 'h') : '-');
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/duration.pipe.ts